import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from '@common/interfaces/id';
import { IArticoloPortaleOloFE } from "@common/interfaces/olo";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";

export interface ArticoloPortaleOloState extends EntityState<IArticoloPortaleOloFE, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.ARTICOLO_PORTALE_OLO_FE })
export class ArticoloPortaleOloStore extends EntityStore<ArticoloPortaleOloState> {
  constructor() {
    super([]);
  }
}
